export default __webpack_public_path__ + "static/media/97_footer_expense.8e622159.png";